import axios from "@/plugins/axios";
// import Devices from "@/helpers/devices";
/**
 * Initial state
 */
export const state = {
  gateways: null,
  gatewaySearch: "",
  loading: true,
  gatewaysNames: [],
};

/**
 * Mutations
 */
export const mutations = {
  ["SET_GATEWAYS"](state, gateways) {
    // setTimeout(() => {
    // gateways = Devices.analyze(devices);
    // Devices.store(devices);
    state.gateways = gateways;
    state.loading = false;
    // }, 5000);
  },
  // ["REANALAYZE_DEVICES"](state, devices) {
  //   devices = Devices.analyze(state.devices);
  //   Devices.store(devices);
  //   state.devices = devices;
  // },
  // ["SET_DAILY_LOGS"](state, data) {
  //   state.dailyLogs[data.slug] = data.logs;
  //   state.hasDailyLogs.push(data.slug);
  // },
  // ["SET_ANALYZED_DEVICES"](state, devices) {
  //   Devices.store(devices);
  //   state.devices = devices;
  // },
  // ["SET_DEVICES_FAILURE"](state) {
  //   console.error("SET_DEVICES_FAILURE");
  //   state.devices = null;
  // },
  // ["START_LOADING"](state) {
  //   // Vue.set(state, "loading", true);
  //   state.loading = true;
  // },
  ["SET_GATEWAY"](state, gateway) {
    // console.log("device is", device);
    let gateways = state.gateways;
    if (gateway.slug) {
      // const newGateway = Devices.analyzeItem(device[0]);
      gateways[gateway.slug] = gateway;
      // Vue.set(state.devices, data[0].slug, device);
      // Devices.store(devices);
      // state.devices = devices;
    } else {
      // const newGateway = Devices.analyzeItem(device[0]);
      gateways[gateway.slug] = gateway;
      // Devices.store(devices);
    }
    state.gateways = gateways;
  },
  ["UNSET_GATEWAY"](state, slug) {
    // Vue.delete(state.devices, slug);
    let gateways = state.gateways;
    delete gateways[slug];
    state.gateways = gateways;
    // Devices.store(state.devices);
  },
  // ["START_DEVICES_FETCHING"](state) {
  //   state.fetching = true;
  // },
  // ["END_DEVICES_FETCHING"](state) {
  //   state.fetching = false;
  // },
  // ["START_FETCHING_LOGS"](state) {
  //   state.fetchedLogs = true;
  // },
  // ["SEARCH_DEVICES"](state, search) {
  //   state.deviceSearch = search;
  //   // console.log("state.deviceSearch", state.deviceSearch);
  // },
  ["LOGOUT"](state) {
    state.gateways = null;
    state.loading = true;
    state.gatewaysNames = [];
  },
  ["SET_GATEWAYS_NAMES"](state, data) {
    // console.log("data is", JSON.parse(JSON.stringify(data)));
    state.gatewaysNames = JSON.parse(JSON.stringify(data));
  },
  ["EDIT_GATEWAY_NAME"](state, data) {
    let names = state.gatewaysNames;
    names
      .filter((n) => n.gateway == data.identifier)
      .map((n) => {
        n.name = data.name;
        return n;
      });
    state.gatewaysNames = names;
  },
};

/**
 * Actions
 */
export const actions = {
  logOut({ commit }) {
    // this.reset();
    commit("LOGOUT");
  },
  async getGatewaysNames({ commit }) {
    await axios
      .get("/gateways")
      .then((res) => {
        // console.log("res", res.data);
        if (res.data) {
          commit("SET_GATEWAYS_NAMES", res.data);
          // this.gatewaysNames = res.data;
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  },
  async getGateways({ commit }) {
    await axios
      .get("/gateways/all")
      .then((res) => {
        // console.log("res", res.data);
        if (res.data) {
          commit("SET_GATEWAYS", res.data.data);
          // this.gatewaysNames = res.data;
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  },
  async getGateway({ commit }, gateway) {
    await axios
      .get(`/gateways/${gateway}`)
      .then((res) => {
        // console.log("res", res.data.data);
        if (res.data) {
          commit("SET_GATEWAY", res.data.data);
          // this.gatewaysNames = res.data;
        }
      })
      .catch((err) => {
        console.log("err", err);
      });
  },

  async editGateName({ commit }, gateway) {
    let gat = {};
    gat.gateway = gateway.identifier;
    gat.name = gateway.name;
    gat.user = gateway.user;

    await axios
      .post(`/gateways/${gat.gateway}/name`, gat)
      .then((res) => {
        if (res.data) {
          // commit("EDIT_GATEWAY_NAME", res.data);
          commit("EDIT_GATEWAY_NAME", gateway);
          this.dispatch("general/setAlert", {
            type: "success",
            msg: "changeName",
          });
        }
      })
      .catch((err) => {
        this.dispatch("general/setAlert", {
          type: "failed",
          msg: "oops",
        });
        console.log("err", err);
      });
  },

  setGateway({ commit }, gateway) {
    commit("SET_GATEWAY", gateway);
  },
  // startLoading({ commit }) {
  //   commit("START_LOADING");
  // },
  // async modifyDevice({ commit }, data) {
  //   let action = data.action ? data.action : "modify";
  //   await axios
  //     .post(`/devices/${data.slug}/${action}`, data.modify)
  //     .then((res) => {
  //       // console.log("the res is", res.data);
  //       if (res.data.success) {
  //         if (action === "delete") {
  //           commit("UNSET_DEVICE", data.slug);
  //         } else {
  //           commit("SET_DEVICE", [res.data.success, true]);
  //         }
  //       }
  //       return true;
  //     })
  //     .catch((err) => {
  //       console.error("err is:", err);
  //       if (!err.message.includes("500")) {
  //         this.dispatch("general/setAlert", {
  //           type: "failed",
  //           msg: "oops",
  //         });
  //       }
  //       return false;
  //     });
  // },

  setSearchGateway({ commit }, search) {
    commit("SEARCH_GATEWAYS", search);
  },
};

/**
 * Getters
 */
export const getters = {
  gNames: (state) => state.gatewaysNames,
  loading: (state) => state.loading,
  gatewaySearch: (state) => state.gatewaySearch,
  gateways: (state) => {
    const gateways = state.gateways ? state.gateways : null;
    // console.log("devices is", devices);
    if (gateways) {
      const sortable = Object.values(gateways).sort(() => {
        const o1 = 2048;
        const o2 = 2049;
        return o1 - o2;
      });
      let mapped = {};
      for (let gateway in sortable) {
        if (
          // sortable.hasOwnProperty(device) &&
          sortable[gateway] &&
          sortable[gateway].slug
        ) {
          // if (sortable[gateway].view && sortable[device].view.visibility) {
          mapped[sortable[gateway].slug] = sortable[gateway];
          // }
        }
      }
      return mapped;
    } else {
      return {};
    }
  },
  // allGateway: (state) => {
  //   const devices = state.devices ? state.devices : Devices.get();
  //   if (devices) {
  //     const sortable = Object.values(devices)
  //       .filter((d) => d.active != 0)
  //       .sort((a, b) => {
  //         const o1 = a.view && a.view.order ? a.view.order : 2048;
  //         const o2 = b.view && b.view.order ? b.view.order : 2049;
  //         return o1 - o2;
  //       });
  //     // const sortable = Object.values(devices).sort((a,b) => a.view.order - b.view.order);
  //     let mapped = {};
  //     for (let device in sortable) {
  //       if (device in sortable && sortable[device] && sortable[device].slug) {
  //         mapped[sortable[device].slug] = sortable[device];
  //       }
  //     }
  //     return mapped;
  //   } else {
  //     return {};
  //   }
  // },
  gatewaysCount: (state, getters) =>
    getters.gateways ? Object.keys(getters.gateways).length : null,
  gateway: (state) => (mac) => {
    // console.log("mac is", mac, state.gateways);
    return state.gateways
      ? Object.values(state.gateways).filter((g) => g.mac == mac)[0]
      : null;
  },
  // loading: (state, getters) =>
  //   Object.keys(getters.devices).length ? false : state.loading,
  // fetching: (state) => state.fetching,
  // gateways: (state) => {
  //   let gateways = {};
  //   Object.values(state.devices).forEach((d) => {
  //     if (d.data && d.data.signal) {
  //       const signal = d.data.signal;
  //       // console.log("signal", signal);
  //       for (const identifier in signal) {
  //         if (!(identifier in gateways))
  //           gateways[identifier] = { identifier, devices: [] };
  //         // signal[identifier].identifier = identifier;
  //         gateways[identifier].devices.push({
  //           identifier: d.identifier,
  //           slug: d.slug,
  //           rssi: signal[identifier].rssi,
  //           received_at: signal[identifier].received_at,
  //         });
  //       }
  //     }
  //   });
  //   return gateways;
  // },
};
